import { render, staticRenderFns } from "./RSVPRegistration.vue?vue&type=template&id=74d97bdf"
import script from "./RSVPRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./RSVPRegistration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RSVPRegistration.vue?vue&type=style&index=0&id=74d97bdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports